// DashboardHeader.jsx

function DashboardHeader({
  filters,
  setFilters,
  onRefresh,
  loading,
  isRefreshing,
  lastUpdated,
}) {
  const handleChange = (event) => {
    const { name, value } = event.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <header
      className={`dashboard-topbar ${
        isRefreshing ? "is-refreshing" : ""
      }`}
    >
      <div className="topbar-left">
        <div
          className={`live-badge ${
            isRefreshing ? "refreshing" : ""
          }`}
        >
          {isRefreshing ? (
            <span className="header-refresh-spinner" />
          ) : (
            "Live"
          )}
        </div>

        <div className="topbar-title-content">
          <div className="topbar-title-row">
            <h1>Manufacturing Dashboard</h1>

            <span
              className={`dashboard-header-status ${
                isRefreshing
                  ? "is-refreshing"
                  : "is-live"
              }`}
            >
              {isRefreshing ? "Refreshing" : "Live"}
            </span>
          </div>

          {isRefreshing ? (
            <div className="dashboard-header-refresh-info">
              <strong>
                Refreshing live production data
              </strong>

              <span>
                Updating cards and charts without reloading the page.
              </span>
            </div>
          ) : (
            <p>
              Last updated: {lastUpdated || "-"}
            </p>
          )}
        </div>
      </div>

      <div className="topbar-filters">
        <div className="field-box">
          <label htmlFor="dashboard-from-date">
            From Date
          </label>

          <input
            id="dashboard-from-date"
            type="date"
            name="fromDate"
            value={filters.fromDate}
            onChange={handleChange}
          />
        </div>

        <div className="field-box">
          <label htmlFor="dashboard-to-date">
            To Date
          </label>

          <input
            id="dashboard-to-date"
            type="date"
            name="toDate"
            value={filters.toDate}
            onChange={handleChange}
          />
        </div>

        <div className="field-box target-box">
          <label htmlFor="dashboard-target-production">
            Target Production
          </label>

          <input
            id="dashboard-target-production"
            type="number"
            name="targetProduction"
            value={filters.targetProduction}
            onChange={handleChange}
          />
        </div>

        <button
          type="button"
          className="refresh-button"
          onClick={onRefresh}
          disabled={loading || isRefreshing}
          aria-label="Refresh dashboard"
          title="Refresh dashboard"
        >
          {loading || isRefreshing ? (
            <span className="refresh-button-spinner" />
          ) : (
            <i className="bi bi-arrow-clockwise" />
          )}
        </button>
      </div>
    </header>
  );
}

export default DashboardHeader;

